'use strict';

import { connect } from 'react-redux';
import
{
	firstpageSelector,
	resourceStatusSelector
} from '../../selectors';

var React = require('react');
var TopTeasers = require('./TopTeasers');
var BottomTeasers = require('./BottomTeasers');
var NewsUrgent = require('../news/NewsUrgent.jsx');
var PageLoader = require('../PageLoader');
var News = require('../news/News.jsx');
var LoadAction = require('../../actions').loadFirstpage;

var executeLoadActions	 = require('../../addons/executeLoadActions');
var Immutable = require('immutable');

class FirstpageHandler extends React.Component {
	render() {

		if(this.props.status === 'RESOURCE_STATUS_FETCHING') {
			return (
				<PageLoader key="loading-firstpage"/>
			);
		}

		const model = this.props.model;
		return (
			<div>
				<NewsUrgent
					destination={model.getIn(['urgent', 'destination'])}
					hero={model.getIn(['urgent', 'hero'], Immutable.List()).toJS()[0]}
					teasers={model.getIn(['urgent', 'teasers'], Immutable.List())}
					screamer={model.getIn(['urgent', 'screamer'], Immutable.Map())}
					banner={model.getIn(['urgent', 'banner'], Immutable.Map())}
					topStory={model.getIn(['topNews'], Immutable.List()).toJS()[0]}
				/>
				<TopTeasers hero={model.get('hero', Immutable.List()).toJS()[0]} topEditorials={model.get('topEditorials', Immutable.List())} />
				<News model={model.getIn(['news'], Immutable.Map()).toJS()} hero={model.getIn(['urgent', 'hero'], Immutable.List()).toJS()[0]} />
				<BottomTeasers editorials={model.getIn(['editorials'], Immutable.List())} otherEditorials={model.getIn(['otherEditorials'], Immutable.List())} />
			</div>
		);
	}
}
FirstpageHandler.handlerActions = [LoadAction];
FirstpageHandler.contextTypes = {
	store: React.PropTypes.object.isRequired
};

function select(state) {
	return {
		status: resourceStatusSelector(state, { type:'pages', id:'frontpage' }),
		model: firstpageSelector(state)
	};
}

export default connect(select)(executeLoadActions(FirstpageHandler));



/** WEBPACK FOOTER **
 ** ./app/components/FirstpageHandler/index.js
 **/